import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  OnDestroy,
} from '@angular/core';
import { Observable, combineLatest, Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { CompanySubset } from 'app/api/company.api.service';
import { IPlEntry } from './pl.types';
import { PlActions } from './actions';
import { AnalyticsSelectors } from 'app/main/analytics/selectors';
import { AnaGroupRow } from 'app/main/analytics/analytics-groups/analytics-groups.component';
import { map, combineAll, takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { CompaniesSelectors, CompaniesUISelectors } from '../company/selectors';
import { fuseAnimations } from '@fuse/animations';
import * as _ from 'lodash';
import { PlSelectors } from './selectors';

@Component({
  selector: 'app-pl',
  templateUrl: './pl.component.html',
  styleUrls: ['./pl.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class PlComponent implements OnInit, OnDestroy {
  editMode = false;
  sortChanged = false;
  yearSetted = false;
  dataLoaded = false;
  selectedEntries: IPlEntry[] = [];
  selectedEntriesCalculated: IPlEntry[] = [];
  rowGroup$: Observable<AnaGroupRow[]>;
  rowAna2$: Observable<AnaGroupRow[]>;
  rowCalculated: IPlEntry[];

  fieldType: string;
  fieldOperator: string;

  public plAgGrid;
  public suppressRowDrag = true;

  public hideGroups = ['Coût Paye', 'Axe Paye'];
  public aggridReady = false;
  public showAna3 = false;

  // Route data
  public pageTitle;
  public viewType;
  loading$: Observable<boolean>;
  unsubscribeAll: Subject<boolean>;
  company: CompanySubset;

  constructor(
    private store: Store<AppState>,
    protected activatedRoute: ActivatedRoute
  ) {
    this.pageTitle = activatedRoute.snapshot.data['title'];
    this.viewType = activatedRoute.snapshot.data['view'];
    this.unsubscribeAll = new Subject();
    this.dataLoaded = false;
  }
  
  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  
  ngOnInit(): void {
    this.store
      .pipe(
        takeUntil(this.unsubscribeAll),
        select(CompaniesSelectors.selectCurrentCompany)
      )
      .subscribe((company) => {
        this.company = company;
        this.yearSetted = false;
        this.dataLoaded = false;
      });

    this.rowGroup$ = this.store.pipe(
      takeUntil(this.unsubscribeAll),
      select(AnalyticsSelectors.selectAnaGroups),
      map((anaGroups) =>
        anaGroups.filter((anaGp) => this.hideGroups.indexOf(anaGp.name) < 0)
      )
    );
    this.rowAna2$ = this.store.pipe(
      takeUntil(this.unsubscribeAll),
      select(AnalyticsSelectors.selectAnalyticsByAxis('ana2')),
      map((ana2) => _.sortBy(ana2, 'sortOrder'))
    );

    // Set CurrentCompany URL
    this.store
      .pipe(
        takeUntil(this.unsubscribeAll),
        select(CompaniesUISelectors.selectCurrentCompanyId)
      )
      .subscribe((companyId) => {
        window.history.pushState({}, '', `/pl/${companyId}`);
        // this.editMode = false;
        // this.suppressRowDrag = true;
      });

    this.store
      .pipe(
        takeUntil(this.unsubscribeAll),
        select(CompaniesUISelectors.selectCurrentPeriod)
      )
      .subscribe((years) => {
        if (years) {
          this.yearSetted = true;
        }
        this.dataLoaded = false;
      });

    this.store
      .pipe(takeUntil(this.unsubscribeAll), select(PlSelectors.selectAnaPL))
      .subscribe((payload: any) => {
        this.dataLoaded = true;
      });
  }

  onCancelSort(): void {}

  onSaveSort(): void {}

  onDelete(): void {
    if (this.selectedEntries.length > 0) {
      this.store.dispatch(
        PlActions.plDeleteRequested({
          entries: this.selectedEntries,
        })
      );
    }
  }

  // onAddToCalculated(): void {
  //   this.rowCalculated = this.selectedEntriesCalculated;
  //   this.selectedEntriesCalculated = [];
  //   this.plAgGrid.api.deselectAll();
  // }

  addBlankRow(): void {
    this.store.dispatch(
      PlActions.plAddRowRequested({
        entry: {
          name: '',
          companyId: '',
          key: String(new Date().valueOf()),
          fieldType: 'blank',
        },
      })
    );
  }

  onSelectionChanged(entries: IPlEntry[]): void {
    this.selectedEntries = entries || [];
  }

  plAgGridReady(params): void {
    this.plAgGrid = params;
    this.aggridReady = true;
  }

  gridDragOver(event): void {
    const dragSupported = event.dataTransfer.types.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'move';
    }
    event.preventDefault();
  }

  gridDrop(event): void {
    event.preventDefault();
    const userAgent = window.navigator.userAgent;
    const isIE = userAgent.indexOf('Trident/') >= 0;
    const jsonData = event.dataTransfer.getData(
      isIE ? 'text' : 'application/json'
    );
    const data = JSON.parse(jsonData);

    this.store.dispatch(
      PlActions.plAddRowRequested({
        entry: {
          ...data,
          fieldType: this.fieldType,
        },
      })
    );
  }

  onToggleChange(): void {
    this.suppressRowDrag = !this.suppressRowDrag;
    this.editMode = !this.editMode;
  }

  showAna3Toggle(): void {}
}
